// extracted by mini-css-extract-plugin
export default {"phoneElement":"phoneElement__4WL9P","phoneInput":"phoneInput__3Vuvk"};
    if(module.hot) {
      // 1764953349514
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  